// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import NavigationBar from "../../Components/NavigationBar";
// import './AccessPage.css';

// export default function ForgotPassword() {
//   const [email, setEmail] = useState("");
//   const [message, setMessage] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [newPassword, setNewPassword] = useState("");
//   const navigate = useNavigate();

//   const generatePassword = () => {
//     return Math.random().toString(36).slice(-8); // Generates a random 8-character password
//   };

//   const handleSubmit = async (e) => {
//     }
      
//   return (
//     <div>
//         <NavigationBar/>
//     <div className="forgot-password-container">
     
//       <div className="forgot-password-box">
//         <h2 className="forgetpasswordtitle">Forgot Password</h2>
//         <Form onSubmit={handleSubmit}>
//           <Form.Group controlId="formEmail" className="form-group">
//             <Form.Label>Enter Your Email:</Form.Label>
//             <Form.Control
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               placeholder="Enter Email"
//               required
//             />
//           </Form.Group>
//           <Button variant="primary" type="submit" className="forgotpasswordbutton">Reset Password</Button>
//         </Form>
//         {message && <p className="forgot-password-message">{message}</p>}
//       </div>
//     </div>
//     </div>
//   );
  
// }

import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import NavigationBar from "../../Components/NavigationBar";
import './AccessPage.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

  const generatePassword = () => {
    return Math.random().toString(36).slice(-8); // Generates a random 8-character password
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newPassword = generatePassword();
    const emailSubject = 'Password Reset for Award Management System';
    const emailBody = `Dear User,\n\nYour password for the Award Management System has been reset.\n\nNew Password: ${newPassword}\n\nPlease use this password to log in and change it immediately for security. If you did not request this reset, please contact us at secretaryurc@gs.pdn.ac.lk.\n\nThis is a system-generated email, please do not reply.\n\nBest regards,\nDirector/URC`;

    try {
      // Send email
      const emailResponse = await axios.post(`${API_BASE_URL}/sendEmail`, {
        to: email,
        subject: emailSubject,
        text: emailBody,
        html: `<p>${emailBody.replace(/\n/g, '<br>')}</p>`,
      });

      if (emailResponse.status !== 200) {
        throw new Error(emailResponse.data.message || 'Failed to send email');
      }

      // Update password and log email
      const response = await axios.post(`${API_BASE_URL}/forgotPassword`, {
        email,
        newPassword,
      });

      setMessage(response.data.message);
      setTimeout(() => navigate('/login'), 3000);

    } catch (error) {
      console.error('Error resetting password:', error);
      setMessage(error.response?.data?.message || 'An error occurred. Please try again.');
    }
  };

  return (
    <div>
      <NavigationBar />
      <div className="forgot-password-container">
        <div className="forgot-password-box">
          <h2 className="forgetpasswordtitle">Forgot Password</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formEmail" className="form-group">
              <Form.Label>Enter Your Email:</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter Email"
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="forgotpasswordbutton">
              Reset Password
            </Button>
          </Form>
          {message && <p className="forgot-password-message">{message}</p>}
        </div>
      </div>
    </div>
  );
}